import Loading from "../../components/Loading";
import PageLayout from "../../layouts/PageLayout";
import QuotationStep from "./QuotationStep/QuotationStep";
import { useGetRouteState } from "../../utils/route.utils";

export default function QuotationAddPage({ editItem }) {
  const { data: existCustomer, redirectTo } = useGetRouteState();

  const id = editItem?.id ?? "";

  const isLoading = false;

  const title = `${!!id ? "Edit" : "Add"} Quotation`;

  const breadCrumbs = [
    {
      name: "Quotation List",
      link: redirectTo ?? "/quotation-list"
    },
    {
      name: title
    }
  ];

  return (
    <PageLayout title={title} breadCrumbs={breadCrumbs}>
      {<Loading loading={isLoading} />}
      <QuotationStep
        title={title}
        editItem={editItem}
        existCustomer={existCustomer}
        redirectTo={redirectTo}
      />
    </PageLayout>
  );
}
